import { ColumnDef } from "@tanstack/react-table";
import { Meeting } from "@/api/calendar";
import { Badge } from "@/components/ui/badge";
import i18n from '@/i18n';
import { IconCalendarEvent, IconBriefcase, IconBuildingCog } from "@tabler/icons-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import InProgressIcon from "@/components/ui/inprogress-icon";

export const userRendezvousColumns = (): ColumnDef<Meeting>[] => {
  return [
    {
      accessorKey: "rendezvous_details",
      header: () => null,
      cell: ({ row }) => {
        const meeting = row.original;
        const isCourt = meeting.tribunal_proc_type;
        const meetingType = isCourt ? i18n.t("court") : i18n.t("office");
        const meetingDate = new Date(meeting.start_time * 1000)
          .toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false })
          .replace(',', '')

        const now = Date.now() / 1000; // Current time in seconds
        const isInProgress = meeting.start_time <= now && (meeting.end_time !== null && meeting.end_time > now);

        return (
          <div className="p-2 border-b border-border last:border-b-0 hover:bg-muted/50 transition-colors">
            <div className="grid grid-cols-2 gap-x-2">
              <div className="flex flex-col items-start justify-start">
                <div className="flex items-center gap-2 mb-0.5">
                  {isCourt ? <IconBuildingCog size={18} className="text-primary flex-shrink-0" /> : <IconBriefcase size={18} className="text-primary flex-shrink-0" />}
                  <span className="font-semibold text-base leading-tight truncate" title={meeting.desc}>{meeting.desc}</span>
                </div>
                {meeting.case && (
                  <div className="text-xs text-muted-foreground truncate" title={meeting.case.name}>
                    {i18n.t("case")}: {meeting.case.name}
                  </div>
                )}
              </div>
              <div className="flex flex-col items-end justify-end">
                <div className="flex items-center gap-1">
                  {isInProgress && (
                    <TooltipProvider delayDuration={100}>
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <div>
                            <InProgressIcon size={18} />
                          </div>
                        </TooltipTrigger>
                        <TooltipContent>
                          <p>{i18n.t("meetingInProgress")}</p>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  )}
                  <Badge variant="outline" className="text-xs mb-0.5">
                    {meetingType}
                  </Badge>
                </div>
                <div className="flex items-center text-xs text-muted-foreground">
                  <IconCalendarEvent size={14} />
                  <span className="flex items-center justify-center w-full">{meetingDate}</span>
                </div>
              </div>
            </div>
          </div>
        );
      },
    },
  ];
};
